const { JOURNEY_TYPE } = require("../../constants");

const getIsCashJourneySelected = journey => journey === JOURNEY_TYPE.CASH;

module.exports = { getIsCashJourneySelected };
